import { DateRange } from "../types";

export class DateHelper {
    static getCurrentWeekDateRange(): DateRange {
        const today = new Date();
        const day = today.getDay();
        const diffToMonday = (day === 0 ? -6 : 1) - day;
        const startDate = new Date(today);
        startDate.setDate(today.getDate() + diffToMonday);
        startDate.setHours(0, 0, 0, 0);

        const endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + 6);
        endDate.setHours(23, 59, 59, 999);

        return [startDate, endDate];
    }

    static getCurrentMonthDateRange(): DateRange {
        const today = new Date();
        const startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        startDate.setHours(0, 0, 0, 0);

        const endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        endDate.setHours(23, 59, 59, 999);

        return [startDate, endDate];
    }

    static getCurrentYearDateRange(): DateRange {
        const today = new Date();
        const startDate = new Date(today.getFullYear(), 0, 1);
        startDate.setHours(0, 0, 0, 0);

        const endDate = new Date(today.getFullYear() + 1, 0, 0);
        endDate.setHours(23, 59, 59, 999);

        return [startDate, endDate];
    }

    static getAllTimeDateRange(): DateRange {
        const startDate = new Date(2022, 0, 1);
        startDate.setHours(0, 0, 0, 0);

        const endDate = new Date(2027, 0, 1);
        endDate.setHours(23, 59, 59, 999);

        return [startDate, endDate];
    }
}
